import { defineMessages } from "react-intl";

export const messages = defineMessages({
  debugTitle: {
    id: "topNav.debug.debugTitle",
    defaultMessage: "Debug",
    description: "Debug dropdown title",
  },
});
